import { getRef } from '@/utils'

export default
  RESET_NEW: ->
    getRef('inventory').child('inventoryNew').set null

  MARK_AS_READ: (_, { path })->
    getRef(path).child('inventoryUnread').set null
